import { Grid } from "@mui/material";
import Input from "../../../../components/input/Input-v2";
import { useGetSubDealers } from "../../../dealer/api/supplier/resolver";
import useGenerateOptions from "../../../../components/input/hook/useGenerateOptions2";
import React, { useState } from "react";

interface GrosirInput {
  control: any;
  disable?: boolean;
}

export default function GrosirInput({ control, disable }: GrosirInput) {
  const [keyword, setKeyword] = useState("");
  const { data: dataRawSubDealers, isLoading: fetchingSubDealer } =
    useGetSubDealers({ keyword });
  const dataSubDealers = dataRawSubDealers?.data.data.data;
  const { data: dataSubDealersOptions } = useGenerateOptions({
    dataSource: dataSubDealers,
    keyForText: "sub_dealer_name",
    keyForValue: "id",
  });
  const isFetching = fetchingSubDealer;

  return (
    <React.Fragment>
      <Grid item xs={12} md={12}>
        <Input.Controller
          control={control}
          name={"sub_dealer_id"}
          rules={{ required: "Kolom ini tidak boleh kosong" }}
          render={(field, fieldState) => (
            <Input.Autocomplete
              showAsStatic={disable}
              disable={disable}
              isFetching={isFetching}
              label="Sub Dealer"
              options={dataSubDealersOptions}
              value={field.value}
              onChange={(e) => setKeyword(e)}
              onClick={(e) => field.onChange(e.value)}
              error={fieldState.error?.message}
            />
          )}
        />
      </Grid>
    </React.Fragment>
  );
}
